export enum MDSTooltipPlacement {
  Top = "top",
  TopLeft = "top left",
  TopRight = "top right",
  Right = "right",
  Bottom = "bottom",
  BottomLeft = "bottom left",
  BottomRight = "bottom right",
  Left = "left",
}

export type IMDSTooltipProps = {
  config?: MDSTooltipConfig;
  children: React.ReactNode;
};

export type MDSTooltipConfig = {
  label: string;
  shortcutLabel?: string;
  placement: MDSTooltipPlacement;
  delaySeconds?: number;
};
